function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { AbstractPublisherTool } from '../../publisher2/tools/AbstractPublisherTool';
var TimeSeriesTool = /*#__PURE__*/function (_AbstractPublisherToo) {
  function TimeSeriesTool() {
    var _this;
    _classCallCheck(this, TimeSeriesTool);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TimeSeriesTool, [].concat(args));
    _this.index = 150;
    _this.group = 'tools';
    _this.allowedLocations = ['top center'];
    _this.lefthanded = 'top center';
    _this.righthanded = 'top center';
    return _this;
  }
  _inherits(TimeSeriesTool, _AbstractPublisherToo);
  return _createClass(TimeSeriesTool, [{
    key: "init",
    value: function init(data) {
      this.controlConfig = {
        showControl: true,
        location: 'top center',
        widthMargin: 200,
        topMargin: '90px'
      };
      if (data && data.configuration && data.configuration.timeseries && data.configuration.timeseries.conf && data.configuration.timeseries.conf.plugins) {
        // Update control configuration according to app setup
        var plugin = data.configuration.timeseries.conf.plugins.find(function (plugin) {
          return plugin.id === 'Oskari.mapframework.bundle.timeseries.TimeseriesControlPlugin';
        });
        if (plugin) {
          this.controlConfig = plugin.config;
        }
      }
      // hide timeseries control if tool is disabled
      if (this.isDisabled()) {
        this.controlConfig.showControl = false;
      }
      if (this.isDisplayed()) {
        // Apply configuration
        this.setEnabled(this.controlConfig.showControl);
      }
    }
  }, {
    key: "getTool",
    value: function getTool() {
      return {
        id: 'Oskari.mapframework.bundle.timeseries.TimeseriesControlPlugin',
        title: Oskari.getMsg('timeseries', 'publisher.TimeseriesControlPlugin.toolLabel')
      };
    }

    /**
    * Set enabled.
    * @method setEnabled
    * @public
    *
    * @param {Boolean} enabled is tool enabled or not
    */
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled) {
      this.state.enabled = enabled;

      // Set control visibility by updating it's config.
      this.controlConfig.showControl = enabled;
      this._updateTimeseriesPluginConfig();
    }

    /**
    * Is this tool disabled.
    * @method isDisabled
    * @public
    *
    * @returns {Boolean} is tool disabled
    */
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      var service = this._getTimeseriesService();
      return typeof service === 'undefined' || typeof service.getActiveTimeseries() === 'undefined';
    }

    /**
     * Don't show the tool if this code is loaded BUT the timeseries bundle is not started as part of the appsetup
     */
  }, {
    key: "isDisplayed",
    value: function isDisplayed() {
      return typeof this._getTimeseriesService() !== 'undefined';
    }

    /**
    * Get values.
    * @method getValues
    * @public
    *
    * @returns {Object} tool value object
    */
  }, {
    key: "getValues",
    value: function getValues() {
      if (this.state.enabled) {
        return {
          configuration: {
            timeseries: {
              conf: {
                plugins: [{
                  id: this.getTool().id,
                  config: this.controlConfig
                }]
              },
              state: this.getSandbox().getStatefulComponents().timeseries.getState()
            }
          }
        };
      } else {
        // Don't include timeseries at all
        return null;
      }
    }

    /**
    * Stop tool.
    * @method stop
    * @public
    */
  }, {
    key: "stop",
    value: function stop() {
      if (this.controlConfig) {
        this.controlConfig = null;
        this._updateTimeseriesPluginConfig();
      }
    }

    /**
     * Sends configuration request to timeseries module
     *
     * @method _updateTimeseriesPluginConfig
     * @private
     */
  }, {
    key: "_updateTimeseriesPluginConfig",
    value: function _updateTimeseriesPluginConfig() {
      var requestBuilder = Oskari.requestBuilder('Timeseries.ConfigurationRequest');
      this.__sandbox.request('Publisher2', requestBuilder(this.controlConfig));
    }
  }, {
    key: "_getTimeseriesService",
    value: function _getTimeseriesService() {
      if (!this.service) {
        this.service = this.__sandbox.getService('Oskari.mapframework.bundle.timeseries.TimeseriesService');
      }
      return this.service;
    }
  }]);
}(AbstractPublisherTool); // Attach protocol to make this discoverable by Oskari publisher
Oskari.clazz.defineES('Oskari.publisher.TimeSeriesTool', TimeSeriesTool, {
  protocol: ['Oskari.mapframework.publisher.Tool']
});
export { TimeSeriesTool };